export default __webpack_public_path__ + "static/media/buttonActionActive.eefd8094.svg";